import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function ssnSubjectMismatchValidator(recordsFormArray: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const subjectToSSNMap: { [subject: string]: { employmentSS: string, irsSS: string, socialSecuritySS: string }[] } = {};
        const errors: ValidationErrors = { ssnSubjectMismatch: [] };
        for (const record of recordsFormArray.controls) {
            const subject = record.get('subject')?.value;
            const employmentSSControl = record.get('employment.employmentSS');
            const irsSSControl = record.get('irs.irsSS');
            const socialSecuritySSControl = record.get('socialSecurity.socialSecuritySS');

            const selectedTypesControl = record.get('selectedTypes')?.value;
            const employmentSS = selectedTypesControl?.includes('employment') ? employmentSSControl.value : null;
            const irsSS = selectedTypesControl?.includes('irs') ? irsSSControl.value : null;
            const socialSecuritySS = selectedTypesControl?.includes('social-security') ? socialSecuritySSControl.value : null;

            const ssnValues: any = { employmentSS, irsSS, socialSecuritySS };
            const enabledSSNs = Object.keys(ssnValues).filter(key => ssnValues[key] !== null);

            if (enabledSSNs.length > 1) {
                const firstEnabledSSN = ssnValues[enabledSSNs[0]];

                for (let i = 1; i < enabledSSNs.length; i++) {
                    const currentSSN = ssnValues[enabledSSNs[i]];

                    if (currentSSN !== firstEnabledSSN) {
                        if (!errors["ssnSubjectMismatch"].includes(subject)) {
                            errors["ssnSubjectMismatch"].push(subject);
                        }
                        break;
                    }
                }
            }

            if (subject) {
                if (!subjectToSSNMap[subject]) {
                    subjectToSSNMap[subject] = [];
                }
                subjectToSSNMap[subject].push({ employmentSS, irsSS, socialSecuritySS });
            }
        }

        for (const subject in subjectToSSNMap) {
            const ssns = subjectToSSNMap[subject];
            const referenceSSNs: any = ssns[0];

            for (const ssnSet of ssns) {
                const { employmentSS, irsSS, socialSecuritySS } = ssnSet;
                const ssnValues: any = { employmentSS, irsSS, socialSecuritySS };
                const enabledSSNs = Object.keys(ssnValues).filter(key => ssnValues[key] !== null);
                const refValue = Object.keys(referenceSSNs).filter(key => referenceSSNs[key] !== null)[0];

                for (const enabledSSN of enabledSSNs) {
                    if (referenceSSNs[refValue] && ssnValues[enabledSSN] !== referenceSSNs[refValue]) {
                        if (!errors["ssnSubjectMismatch"].includes(subject)) {
                          console.log("22")
                            errors["ssnSubjectMismatch"].push(subject);
                        }
                        break;
                    }
                }
            }
        }

        return errors["ssnSubjectMismatch"].length > 0 ? { ssnSubjectMismatch: errors["ssnSubjectMismatch"] } : null;
    };
}
